import { LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import SubmitFormButton from 'common/components/submit-form-button.component';
import { AuthType } from 'config/constants/auth.constants';
import { AuthTranscription } from 'config/constants/transcription.constant';
import AuthService from 'config/services/auth.service';
import GlobalUtils from 'config/utils/globals.util';
import NavigationUtils from 'config/utils/navigation.util';
import { SnackbarUtilities } from 'config/utils/snackbar.util';
import UserUtils from 'config/utils/user.util';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AnyAction, Dispatch } from 'redux';
import { AuthSlice } from 'store/slices/auth.slice';
import styles from './style.module.scss';
import { getErrorMessage } from 'config/utils/errors.util';

type RecoverPassProps = {
  callBack?: () => void;
};

const RecoverPassForm: React.FC<RecoverPassProps> = ({ callBack }) => {
  const dispatch: Dispatch<AnyAction> = useDispatch();
  const [recoverForm] = Form.useForm();
  const location: Partial<Location> = useLocation();

  const handleSubmit = async () => {
    dispatch(AuthSlice.fetchingRefresh(true));
    try {
      await AuthService.recoverPassword({ email: recoverForm.getFieldValue('email') });
      const successMessage = GlobalUtils.replaceTranslateKey(
        AuthTranscription.RECOVER_PASSWORD_SENT_TOKEN,
        'mail',
        recoverForm.getFieldValue('email'),
      );
      SnackbarUtilities.success(successMessage);
    } catch (e: unknown) {
      SnackbarUtilities.error(getErrorMessage(e, AuthTranscription.ERROR_RECOVER_PASSWORD));
    } finally {
      dispatch(AuthSlice.fetchingRefresh(false));
      callBack && callBack();
    }
  };

  return (
    <div className={styles['recover-pass-form-component']}>
      <Form form={recoverForm} name='standard-login' layout='vertical' autoComplete='on' onFinish={handleSubmit}>
        <Form.Item name='email' rules={UserUtils.emailFieldRules} shouldUpdate validateFirst>
          <Input
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder={AuthTranscription.FORM_EMAIL_PLACEHOLDER}
            name='email'
            type='email'
          />
        </Form.Item>
        <Form.Item>
          <SubmitFormButton form={recoverForm} text={AuthTranscription.FORM_RECOVER_PASSWORD_TEXT} icon={<LoginOutlined />} /> &nbsp; O
          volver a
          <Button type='link' onClick={() => NavigationUtils.handleAuthTypeAction(AuthType.LOGIN, true, null, location)}>
            {AuthTranscription.FORM_LOGIN_TEXT}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default RecoverPassForm;
